module.exports = __webpack_public_path__ + "static/media/capa_letracaixa.2ec79953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/capa_letracaixa.jpg
// module id = 349
// module chunks = 0